import { useLocationSearch } from "hooks/useLocationSearch"

const available_filters = [
  "marketId",
  "companyId",
  "clientId",
  "supplierId",
  "channelId",
  "mediaTypeSemantics",
  "startDate",
  "endDate",
  "currency",
] as const

type AvailableFilter = (typeof available_filters)[number]

type UseFiltersProps = {
  filters?: AvailableFilter[]
}

function useFilters(props?: UseFiltersProps) {
  const filters = props?.filters ?? available_filters
  const ls = useLocationSearch()
  const getFilterValue = (key: AvailableFilter) => ls.get(key, "")!
  const getSearchParams = (): string | undefined => {
    const ps = new URLSearchParams()

    filters.forEach((filterKey) => {
      const v = getFilterValue(filterKey)
      if (Boolean(v.trim())) {
        ps.set(filterKey, v)
      }
    })
    return ps ? ps.toString() : undefined
  }

  return {
    key: ls.search,
    getSearchParams,
  }
}

export default useFilters
